import useMediaQuery from '@mui/material/useMediaQuery';

export const useMediaPhone = () => useMediaQuery('(max-width:1100px)');
